import { createSlice } from "@reduxjs/toolkit";
import { DownloadEkoReport } from "../Apis/DownloadEkoReport";

export const DownloadEkoReportSlice = createSlice({
  name: "downloadekoreport",
  initialState: {
    downloadekoreport: null,
    authenticatingdownloadekoreport: false,
    authenticated: false,
    isError: false,
    errors: null
  },
  reducers: {
    clearState: (state) => {
      state.downloadekoreport = null;
      state.isError = false;
      state.authenticated = false;
      state.authenticatingdownloadekoreport = false;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(DownloadEkoReport.fulfilled, (state, action) => {
      state.downloadekoreport = action.payload;
      state.authenticated = false;
      state.authenticatingdownloadekoreport = false;
      return state;
    });
    builder.addCase(DownloadEkoReport.pending, (state, action) => {
      state.authenticatingdownloadekoreport = true;
      state.authenticated = true;
    });
    builder.addCase(DownloadEkoReport.rejected, (state, action) => {
      state.errors = action.errors || action.payload;
      state.authenticated = false;
      state.authenticatingdownloadekoreport = false;
      state.isError = true;
      return state;
    });
  }
});

export const { clearState } = DownloadEkoReportSlice.actions;

export const DownloadEkoReportSelector = (state) => state.downloadekoreport;
